<script setup lang="ts">
const i18nHead = useLocaleHead({})

useHead({
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs?.lang,
  },
  link: [...(i18nHead.value.link || [])],
  meta: [...(i18nHead.value.meta || [])],
})
</script>

<template lang="pug">
.layout-container.flex
  .layout.flex-center-center.col-16.w-100p
    .template.br-24.max-w-800.w-100p.h-100p.flex.col-0
      slot
</template>

<style scoped>
.layout-container {
  min-height: max(600px, 100vh);
  @supports (min-height: 100dvh) {
    min-height: max(600px, 100dvh);
  }

  @screen md {
    /* max-height: max(800px, 100dvh); */
  }
}

.layout {
  --uno: p-b-16;
  @screen md {
    --uno: p-20;
  }
}

.template {
  /* overflow: hidden; */
  background: var(--cue-bg-surface-primary);

  @screen md {
    box-shadow: 0 0 2px color-mix(in srgb, var(--cue-static-neutral-inverse) 20%, transparent);
  }
}
</style>

<style>
body {
  @screen md {
    background: var(--cue-bg-surface-main);
  }
}
</style>
